<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-02 17:23:49
 * @FilePath: \Home\Transfor-website\src\views\pc\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="background-color: #000 !important">
    <div class="homes">
      <div class="home-W">
        <div class="logoall">
          <div class="logo" @click="jump('#About1')">
            <div class="logo_all">
              <img src="@/assets/pc/Index/logo.png" />
              <!-- <img src="../../assets/pc/Home/HomeLogo.svg" alt="" /> -->
              <!-- <div class="Home_logo">Transformers</div> -->
            </div>
          </div>
          <div class="menu">
            <ul>
              <li>
                <p @click="jump('#About')">About</p>
              </li>
              <li>
                <p @click="jump('#Mission')">Investment Direction</p>
              </li>
              <li>
                <p @click="jump('#Service')">Investment Process</p>
              </li>
              <li>
                <p class="pclas" @click="jump('#Stratagem')">NFT Plan</p>
              </li>
              <!-- <li>
              <p @click="jump('#Team')">Team</p>
            </li> -->
              <li>
                <p @click="jump('#Contact')">Participation Avenues</p>
              </li>
              <li>
                <p @click="jump('#FoundNft')">Foundation</p>
              </li>
              <li>
                <p @click="jump('#Products')">Investment products</p>
              </li>
              <!-- <li>
                <p @click="showTestbox">
                  Social<img :src="testflog1 == true ? imgloga : imglogo" />
                </p>
                <div
                  class="menubox"
                  v-show="testflog1"
                  @mouseover="showTestbox1"
                  @mouseout="hideTestbox1"
                >
                  <a href="https://twitter.com/faircrypt01" target="_blank"
                    ><div class="menuboxli">X</div></a
                  >
                  <a href="https://medium.com/@faircrypto" target="_blank"
                    ><div class="menuboxli">Medium</div></a
                  >
                  
                  <a
                    href="https://mirror.xyz/0x23A1E6cd8196Caad2548240bd662b87Ae7ed2D08/subscribe"
                    target="_blank"
                    ><div class="menuboxli">Mirror</div></a
                  >
                
                </div>
              </li> -->
              <!-- 注册开始 -->
              <li class="signtop">
                <div
                  class="sign"
                  @click="login"
                  v-if="userEmail == null || userEmail == ''"
                >
                  <span> Sign in</span>
                </div>
                <div
                  class="sign1"
                  @mouseover="showaddressbox"
                  @click="showaddressbox"
                  v-else
                >
                  {{ userEmail }}
                </div>
                <!-- v-show="flog1" -->
                <div
                  class="addressbox addressbox1"
                  v-if="isBindAddress == 0 && userEmail !== ''"
                  v-show="testflog"
                  @mouseover="showaddressbox"
                  @mouseout="hideaddressbox"
                >
                  <div class="boxli">
                    <div class="boxlitit">USDT Lock-up Address:</div>
                    <div class="boxlicon">Not yet bound</div>
                  </div>
                  <!-- <div class="boxli boxlis">
                    <div class="boxlitit">DO Lock-up Address:</div>
                    <div class="boxlicon">Not yet bound</div>
                  </div> -->
                  <div class="boxli boxlis">
                    <div class="boxlitit">Token/NFT Receiving Address:</div>
                    <div class="boxlicon">Not yet bound</div>
                  </div>
                  <div class="boxbind">
                    <div class="exit" @click="Exits">Exit</div>
                    <div class="bind" @click="bindclick">
                      Bind wallet address
                    </div>
                  </div>
                </div>
                <div
                  class="addressbox addressbox2"
                  v-if="isBindAddress == 1 && userEmail !== ''"
                  v-show="testflog"
                  @mouseover="showaddressbox"
                  @mouseout="hideaddressbox"
                >
                  <div class="boxli">
                    <div class="boxlitit">
                      USDT Locked Address ({{ coinType }}):
                    </div>
                    <div class="boxlicon">
                      {{ donationAddress }}
                      <!-- <img
                        src="../../assets/pc/Login/update.png"
                        @click="update"
                      /> -->
                    </div>
                  </div>
                  <!-- <div class="boxli boxlis">
                    <div class="boxlitit">DO Locked Address:</div>
                    <div class="boxlicon">
                      0x1KNktd22DUALp7x664FLJWhoc9cdxk5Ey7
                    </div>
                  </div> -->
                  <div class="boxli boxlis">
                    <div class="boxlitit">
                      Token/NFT Receiving Address(DO Network):
                    </div>
                    <div class="boxlicon">
                      {{ xprlAddress }}
                    </div>
                  </div>
                  <div class="hashbox">
                    <div class="boxli boxlis">
                      <div class="boxlitit">USDT locked transaction hash:</div>
                      <div class="boxlicon">
                        <input
                          type="text"
                          placeholder="Please provide the transaction hash for the locked USDT."
                          v-model.trim="coinTxHash"
                          ref="search"
                        />
                      </div>
                    </div>
                    <div class="boxli boxlis">
                      <div class="boxlitit">DO locked transaction hash:</div>
                      <div class="boxlicon">
                        <input
                          type="text"
                          placeholder="Please provide the transaction hash for the locked DO."
                          v-model.trim="txHash"
                          ref="search"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="record" @click="recordlist">
                    PRL-X receiving record
                  </div>
                  <div
                    class="submit"
                    :class="{ disabled: isSubmitting }"
                    @click="hashsubmit"
                  >
                    <div class="loader" v-if="isSubmitting"></div>
                    <img
                      :class="{ hidden: !isSubmitting }"
                      src="../../assets/pc/Index/loading.webp"
                    />
                    Submit
                  </div>
                  <!-- <div class="submit1" @click="hashsubmit1">submit</div> -->
                  <div class="Reminder">
                    <div class="Remindertit">Reminder:</div>
                    <div class="Remindercon">
                      Please ensure that the transaction hash you submit is the
                      transaction hash of the lock-up address bound above.
                    </div>
                    <div class="Remindercon1" @click="Exits">Exit</div>
                  </div>
                </div>
              </li>

              <!-- 注册结束 -->
            </ul>
          </div>
        </div>
      </div>
      <!--消息公告-->
      <div class="marquee-container">
        <div class="marquee-content" :style="marqueeStyle"  @click="noteClick">
          <div class="marquee-message">
              <img src="@/assets/pc/Index/note.png" />
              <span style="margin: 0 10px;">{{ message }}</span>
              <img src="@/assets/pc/Index/point.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 退出登录开始 -->
    <Logout
      v-show="lflog"
      :lflog="lflog"
      @logouts="logouts($event)"
      @email="email($event)"
      @isBind="isBind($event)"
      @loginflog="loginflog($event)"
    ></Logout>
    <!-- 退出登录结束 -->
    <!-- 登录开始 -->
    <Login
      v-show="flog"
      :flog="flog"
      :flogb="flogb"
      :lflog="lflog"
      @loginflog="loginflog($event)"
      @signups="signups($event)"
      @fflog="fflog($event)"
      @email="email($event)"
      @isBind="isBind($event)"
      @donation="donation($event)"
      @xprl="xprl($event)"
      @coinTypes="coinTypes($event)"
    ></Login>
    <!-- 登录结束 -->
    <!-- 注册开始 -->
    <Signup
      v-show="flogb"
      :flogb="flogb"
      :flog="flog"
      @signups="signups($event)"
      @loginflog="loginflog($event)"
    ></Signup>
    <!-- 注册结束 -->
    <!-- 忘记密码开始 -->
    <Resignup
      v-show="flogc"
      :flogc="flogc"
      @loginflog="loginflog($event)"
      @repwd="repwd($event)"
      @back="back($event)"
    ></Resignup>
    <!-- 忘记密码结束 -->
    <!-- 绑定开始 -->
    <Bind
      v-show="bflog"
      :bflog="bflog"
      @bloginflog="bloginflog($event)"
      @donation="donation($event)"
      @xprl="xprl($event)"
      @isBind="isBind($event)"
      @coinTypes="coinTypes($event)"
    ></Bind>
    <!-- 绑定结束 -->
    <!-- 提交的记录开 -->
    <Record
      v-show="rflog"
      :rflog="rflog"
      @bloflog="bloflog($event)"
      :relist="relist"
      :total="total"
    ></Record>
    <!-- 提交的记录结束 -->
    <!-- 公告打开 -->
    <Note
          v-show="rflog"
          :rflog="rflog"
          @bloflog="bloflog($event)"
    ></Note>

  <!-- 公告结束 -->
    <div id="About1">
      <div class="Main-W">
        <div class="Aboutbg">
          <div class="Aboutitle">TO BECOME</div>
          <div class="Aboutcon">
            <span>A</span> knowledgeable Web<span>3</span> <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;accredite<span>d</span> investo<span
              >r</span
            >
          </div>
          <div class="Aboutcon1">Fund</div>
          <div class="Aboutbotm">
            <div class="Aboutbotml">
              Fair, Transparent, Decentralized,<br />
              Rational Investment, Avoiding<br />
              becoming a 'bagholder.'
            </div>
            <div class="Aboutbotmr">
              <!-- <img src="@/assets/pc/Index/xia.png" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="About"></div>
    <div class="About">
      <div class="Main-W">
        <!-- <div class="aboutMission">
          About<img src="@/assets/pc/Index/dian.png" />
        </div> -->
        <div class="Missionbox">
          <div class="Missionboxli">
            <div class="Missionboxlil">
              <div
                class="Missionboxtit"
                style="
                  font-family: Poppins, Poppins;
                  font-weight: 600;
                  font-size: 50px;
                  color: #ffffff;
                "
              >
                About<img
                  src="@/assets/pc/Index/dian.png"
                  style="
                    width: 12px;
                    height: 10px;
                    margin-top: 48px;
                    margin-left: 6px;
                  "
                />
              </div>
              <div class="Missionboximg">
                <!-- <img src="@/assets/pc/Index/1a.png" /> -->
              </div>
            </div>
            <div class="Missionboxlir">
              <div class="Missionboxlirtit">FairCrypto Fund is</div>
              <div class="Missionboxlilcon" style="word-spacing: -2px">
                a novel financial institution in the form of a decentralized
                organization aimed<br />
                at building a diverse digital financial ecosystem to meet the
                needs and preferences of global users.<br />
                We focus on providing secure and efficient digital financial
                services, covering areas such as AI<br />
                computing power, DEPIN, incubation, investment, facilitating the
                transition of Web2 enterprises to<br />
                Web3, Staking, and BTClayer2.
              </div>
            </div>
          </div>
          <div class="Missionboxli">
            <div class="Missionboxlil">
              <div class="Missionboxtit">Mission</div>
              <div class="Missionboximg">
                <img src="@/assets/pc/Index/1a.png" class="img1" />
              </div>
            </div>
            <div class="Missionboxlir">
              <div class="Missionboxlirtit">Our mission is</div>
              <div class="Missionboxlilcon">
                to establish a fair, transparent, and decentralized crypto fund
                system, resisting market<br />
                manipulation and speculative activities, encouraging rational
                investment, and assisting investors<br />
                in avoiding speculative risks.
              </div>
            </div>
          </div>
          <div class="Missionboxli">
            <div class="Missionboxlil">
              <div class="Missionboxtit">Vision</div>
              <div class="Missionboximg">
                <img src="@/assets/pc/Index/1.png" class="img2" />
              </div>
            </div>
            <div class="Missionboxlir">
              <div class="Missionboxlirtit">We are</div>
              <div class="Missionboxlilcon">
                committed to establishing a fair, just, and transparent
                cryptocurrency market, rejecting a culture<br />
                of speculation, and working together with partners to become
                leaders in the WEB3 industry.
              </div>
            </div>
          </div>
          <div class="Missionboxli">
            <div class="Missionboxlil">
              <div class="Missionboxtit">Goals</div>
              <div class="Missionboximg">
                <img src="@/assets/pc/Index/2.png" class="img3" />
              </div>
            </div>
            <div class="Missionboxlir">
              <div class="Missionboxlirtit">Our goal is</div>
              <div class="Missionboxlilcon" style="word-spacing: -2px">
                to address various challenges faced by investors, including
                improving the balance of investment<br />
                returns, enhancing the professionalism of investment project
                evaluations, identifying high-quality <br />investment
                opportunities, and providing financial support to help investors
                better participate in<br />
                the cryptocurrency market.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Mission"></div>
    <div class="Mission">
      <div class="Main-W">
        <div class="Direction">
          Investment Direction<img src="@/assets/pc/Index/dian.png" />
        </div>
        <img src="@/assets/pc/Index/3.png" />
      </div>
    </div>
    <div id="Service"></div>
    <div class="Service">
      <div class="serve">
        <div class="Main-W">
          <div class="Process">
            Investment Process <img src="@/assets/pc/Index/dian.png" />
          </div>
          <div class="Processall">
            <!-- 第一步开始 -->
            <div class="Process1">
              <img src="@/assets/pc/Index/4.png" />
              <span>User Contribution</span>
            </div>
            <!-- 第一步开始 -->
            <div class="Processline"></div>
            <!-- 第二步开始 -->
            <div class="Process2">
              <div>Foundation Multisig Address</div>
              <img src="@/assets/pc/Index/5.png" />
            </div>
            <!-- 第二步结束 -->
            <div class="Processline1"></div>
            <img class="jian" src="@/assets/pc/Index/7.png" />
            <div class="Processline2"></div>
            <!-- 第三步开始 -->
            <img class="Process2a" src="@/assets/pc/Index/6.png" />
            <!-- 第三步结束 -->
            <!-- 第四步开始 -->
            <div class="Process3">
              <div class="box">
                <div class="boxs">24/30 Multisig</div>
                <div class="boxx">
                  <div class="boxxlinea"></div>
                  <img src="@/assets/pc/Index/7.png" />
                  <div class="boxxlinea1"></div>
                </div>
              </div>
              <div class="boxline1"></div>
              <img class="boxleft" src="@/assets/pc/Index/8.png" />
              <div class="boxline2"></div>
              <div class="boxtit">Foundation Investment Targets</div>
              <div class="boxline3"></div>
              <img class="boxright" src="@/assets/pc/Index/9.png" />
              <div class="boxline4"></div>
              <div class="box1">
                <div class="box1s">
                  Foundation<br />
                  Earnings
                </div>
                <div class="box1x">
                  <div class="box1xline"></div>
                  <img src="@/assets/pc/Index/7.png" />
                  <div class="box1xline1"></div>
                </div>
              </div>
            </div>
            <!-- 第四步结束 -->
            <div class="Process4">
              <div class="taep">
                <div class="taep1box">
                  <span>50%</span>
                  Participated by the Foundation
                </div>
              </div>
              <div class="teplines"></div>
              <div class="taep1">
                <div class="taep1box">
                  <span>50%</span>

                  Participated by NFT-Holding<br />Users (Limited Time)
                </div>
                <div class="taep1box1">
                  <div class="line1a"></div>
                  <img class="imga1" src="@/assets/pc/Index/7.png" />
                  <div class="line2a"></div>
                </div>
                <!-- 最后一个开始 -->
                <!-- <div style="display: flex;">
                <div class="taep">
                  <div class="taep1box">
                    <span>50%</span>
                    Participated by the Foundation
                  </div>
                </div>
                <div class="teplines"></div>
                <div class="taep1">
                  <div class="taep1box">
                    <span>50%</span>

                    Participated by NFT-Holding<br />Users (Limited Time)
                  </div>
                </div>
              </div> -->
                <!-- 最后一个结束 -->
              </div>
              <div class="taepline"></div>
              <img src="@/assets/pc/Index/9.png" />
              <div class="taepline"></div>
              <div class="taep2">
                Partially Abandoned for<br />
                Foundation Participation
              </div>
              <div class="taep3">
                <div class="taepcont">
                  <span>10%</span><br />
                  Goes to<br />
                  Signature NFT
                </div>
              </div>
              <div class="teplinesa"></div>
              <div class="taep44">
                <div class="taepcont">
                  <span>10%</span><br />
                  Fund<br />
                  Operation
                </div>
              </div>

              <div class="teplinesb"></div>

              <div class="taep4">
                <div class="taepcont">
                  <span>80%</span>
                  Distributed<br />
                  Based on All User<br />
                  Contributions
                </div>
              </div>
            </div>
            <!-- 第五步结束 -->
            <div class="endteap">
              <div class="taep5">
                <div class="taepcont">
                  <span>20%</span>
                  of Earnings Goes<br />to the Foundation
                </div>
              </div>
              <div class="teplines"></div>
              <div class="taep6">
                <div class="taepcont">
                  <span>80%</span>
                  Goes to Users
                </div>
              </div>
            </div>

            <!-- 第五步结束 -->
            <!-- 第六步结束 -->

            <!-- 第六步结束 -->
          </div>
        </div>
      </div>
    </div>
    <div id="Stratagem"></div>
    <div class="Stratagem">
      <div class="Stratagem">
        <div class="Main-W">
          <div class="NftPlan">
            NFT Plan <img src="@/assets/pc/Index/dian.png" />
          </div>
          <div class="NftPlanbox">
            <div class="NftPlanleft">
              <img class="Nftimg" src="@/assets/pc/Index/10.png" />
              <div class="Nftcon">
                <img src="@/assets/pc/Index/11.png" /><span
                  >Regular NFTs(96%)</span
                >
              </div>
              <div class="Nftcon1">
                <img src="@/assets/pc/Index/12.png" /><span
                  >Signature NFTs(4%)</span
                >
              </div>
            </div>
            <div class="NftPlanright">
              <div class="Nftli">
                <div class="Nftlileft">
                  <div class="Nftdian"></div>
                  <div class="Nftline lineheight"></div>
                </div>
                <div class="Nftliright">
                  The initial release includes<span> 5,200 NFTs</span>, with
                  <span
                    >5,000 being regular<br />
                    NFTs</span
                  >
                  and <span>200 being signature NFTs</span>, both serving as
                  tokens for<br />
                  entry into the foundation.
                </div>
              </div>
              <div class="Nftli">
                <div class="Nftlileft">
                  <div class="Nftdian"></div>
                  <div class="Nftline lineheight1"></div>
                </div>
                <div class="Nftliright">
                  In the initial phase,<span> 30 signature NFTs</span> and<span>
                    2,500<br />
                    regular NFTs</span
                  >
                  will be airdropped.
                </div>
              </div>
              <div class="Nftli">
                <div class="Nftlileft">
                  <div class="Nftdian"></div>
                  <div class="Nftline lineheight2"></div>
                </div>
                <div class="Nftliright">
                  The remaining regular NFTs will be publicly<br />
                  available for sale by the foundation at a price of<br />
                  <span>10 USDT</span> per token, with the proceeds going to<br />
                  the foundation.
                </div>
              </div>
              <div class="Nftli">
                <div class="Nftlileft">
                  <div class="Nftdian"></div>
                </div>
                <div class="Nftliright">
                  NFT holders can participate in the foundation's investment<br />
                  research related to specific projects.
                </div>
              </div>
              <div class="Nftli">
                <div class="Nftlirighta">
                  <span> For example</span>, if the foundation participates
                  with<span> 50%</span> of the <br />allocation in Project A,
                  the remaining <span>50% </span>is open for<br />
                  participation by NFT holders within a specified timeframe.
                  If<br />
                  the deadline passes, the foundation will take up the<br />
                  remaining allocation.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Contact"></div>
    <div class="Mains Contact">
      <div class="Main-W">
        <div class="Foundation">
          Ways to Participate <br />
          in the Foundation <img src="@/assets/pc/Index/dian.png" />
        </div>
        <div class="Foundationli">
          <div class="Foundcon">1</div>
          <div class="concontent">1000</div>
          <img class="img" src="@/assets/pc/Index/13.png" />
          <div class="concontent">+ Locking 2000</div>
          <img class="img1" src="@/assets/pc/Index/20.png" />
          <div class="concontent1">(tokens)</div>
          <img class="img2" src="@/assets/pc/Index/14.png" />
          <div class="concontent2">500PRL + Owning 1 regular NFT</div>
        </div>
        <div class="Foundationli">
          <div class="Foundcon">2</div>
          <div class="concontent">30000</div>
          <img class="img" src="@/assets/pc/Index/13.png" />
          <div class="concontent">+ Locking 50000</div>
          <img class="img1" src="@/assets/pc/Index/20.png" />
          <div class="concontent1">(tokens)</div>
          <img class="img2" src="@/assets/pc/Index/14.png" />
          <div class="concontent2">30000PRL + Owning 1 signature NFT</div>
        </div>
        <div class="Foundbox">
          <div class="Foundboxli">
            The Foundation membership asset lock-up<br />
            period is 18 months, and the locked DO will<br />
            be used for node delegation. The earnings<br />
            generated from node delegation will belong<br />
            to the Foundation.
          </div>
          <div class="Foundboxli Foundboxlia">
            10% of the fund's profits will be allocated to users who own the
            signed NFTs, another 10% will be used for fund operations, and the
            remaining 80% will be distributed to all participating users in
            proportion to their invested funds.
          </div>
          <div class="Foundboxli" style="padding-top: 28px">
            The PRL tokens airdropped by the Foundation have free liquidity. The
            quantity of PRL issued is generated based on the amount of USDT
            flowing into the foundation.
          </div>
        </div>
        <!-- <div class="Foundboxline" @click="toggleVisibility">
          To view the addresses of NFT holders<img
            src="@/assets/m/Index/xia.png"
          />
        </div> -->
        <div class="Foundboxall" v-if="isVisible">
          <div class="tab">
            <button
              v-for="(tab, index) in tabs"
              :key="index"
              @click="activeTab = index"
              :class="{ active: activeTab === index }"
            >
              {{ tab.title }}
            </button>
          </div>
          <div class="tab-content">
            <div v-if="activeTab == 0">
              <div class="tabcontent">
                <!-- <div class="tabtitle">Address</div>
                <div class="tabbox">
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                </div> -->
                <div class="nodata">List is empty</div>
              </div>
            </div>
            <div v-if="activeTab == 1">
              <div class="tabcontent">
                <div class="nodata">List is empty</div>
                <!-- <div class="tabtitle">Address</div>
                <div class="tabbox">
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                </div> -->
              </div>
            </div>
            <!-- <div
              v-for="(tab, index) in tabs"
              :key="index"
              v-show="activeTab === index"
            >
             
              {{ tab.content }}
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div id="FoundNft"></div>
    <div class="FoundNft">
      <div class="FoundNftimg">
        <div class="Main-W">
          <div class="FoundNftbox">
            <div class="FoundNftleft">
              Foundation<img src="@/assets/pc/Index/dian.png" />
            </div>
            <div class="FoundNftright">
              Our trading accounts operate with complete transparency, whether
              on decentralized or<br />
              centralized exchanges, making all transaction information
              accessible to the public. To <br />ensure the security of funds,
              we have established a rigorous monitoring system. All inflows<br />
              and outflows of funds will be publicly disclosed for the
              supervision of our users.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Emailsbox">
      <div class="Main-W">
        <div style="display: flex">
          <!-- <div class="apks">
            <div class="title">FairCrypto Fund Download</div>
            <img src="@/assets/pc/Index/ewm.png" class="erwm" />
            <div class="con">
              Scan the QR code to download <br />
              (Only for Android)
            </div>
           <a href="https://www.faircrypto.fund/apk/FairCrypto.apk"> <div class="download">Download APK</div></a>
          </div> -->
          <div style="margin-left: 200px">
            <div class="Emailli" style="margin-top: 201px">
              <div class="Emaillil">
                <img src="@/assets/pc/Index/16.png" />
              </div>
              <div class="Emaillir">
                Here is the public address information for the Foundation:
              </div>
            </div>
            <div class="Emailtext">
              <div class="Emailtit" style="margin-left: 50px">
                USDT Receiving Address:<span
                  ><br />(Please use the address<br />
                  filled in the Foundation <br />BOT to transfer.)</span
                >
              </div>
              <div class="Emailcon">
                <img
                  src="@/assets/pc/Index/aaaa.png"
                />0x88482E889a13CD0c6b99C4BD6e80539983bEdadC<br />
                <div style="margin-top: 20px">
                  <img src="@/assets/pc/Index/aa.png" />
                  TKh5H1UsQgfbbktDhsAKdp3FHSL9PY3eXK
                </div>
                <br />
                <img src="@/assets/pc/Index/aaa.png" />
                0x5B2573F49ec4f12dAd9B2eA9Da6D98c25A202Ab3
              </div>
              <!-- <div class="Emailcon">TKh5H1UsQgfbbktDhsAKdp3FHSL9PY3eXK</div> -->
            </div>

            <div class="Emailtext1" style="margin-top: 48px">
              <div
                class="Emailtit"
                style="margin-left: 50px; text-align: right"
              >
                DO Receiving Address:
              </div>
              <div class="Emailcon">
                0x8Be0450dFb3c26485Cc9F7CC2ee2B83FB5B496eA
              </div>
            </div>
            <div class="Emailtext1" style="margin-top: 18px">
              <div
                class="Emailtit"
                style="margin-left: 50px; text-align: right"
              >
                Foundation Donation Address (DO):
              </div>
              <div class="Emailcon">
                0xBBB1f96101886BD2b356fc3F8AC4D144da131c1C
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Products"></div>
    <div class="Products">
      <div class="Main-W">
        <div class="Process">
          Investment Process
          <img class="imgs" src="@/assets/pc/Index/dian.png" />
        </div>
        <div class="Productsbox">
          <div v-for="(item, index) in listitems" :key="index">
            <div class="pboxli" @mouseleave="hidetoggleDetails">
              <div :class="detailsClass(index)">
                <img
                  class="imgs"
                  v-if="index == 0"
                  src="@/assets/pc/Login/1.jpg"
                />
                <img
                  class="imgs"
                  v-if="index == 1"
                  src="@/assets/pc/Login/2.jpg"
                />
                <img
                  class="imgs"
                  v-if="index == 2"
                  src="@/assets/pc/Login/3.jpg"
                />
                <img
                  class="imgs"
                  v-if="index == 3"
                  src="@/assets/pc/Login/do.png"
                />
                <div class="pboxlitit">{{ item.productName }}</div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Investment target:</div>
                  <div class="pboxliright pboxlirighta">
                    {{ item.markNameStr }}
                  </div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Total return:</div>
                  <div class="pboxliright">{{ item.totalProfit }} U</div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Total return rate:</div>
                  <div class="pboxliright">{{ item.totalProfitRate }} %</div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Amount:</div>
                  <div class="pboxliright">{{ item.holdAmount }}</div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Address:</div>
                  <div class="pboxliright addrs" v-if="index == 0">
                    1PNuvwszjFqueNz3SDNN7iYaVK59kqVPbU
                  </div>
                  <div class="pboxliright addrs" v-if="index == 1">
                    0x63c7746af7167af7109e013cc8863d7552f309d1
                  </div>
                  <div class="pboxliright addrs" v-if="index == 2">
                    3qtQK64oY2dYswaMcKs57rLX8WFL3g37gEM8vq2RHFaL
                  </div>
                  <div class="pboxliright addrs" v-if="index == 3">
                    0xa438Bf9FF1FaBEE0c22f95c974D683A750cfae39
                  </div>
                </div>
                <div class="pboxline"></div>
                <div
                  class="pboxviews"
                  @mouseover="debounceToggleDetails(index)"
                  v-if="detailsVisible !== index"
                >
                  View Details<img
                    class="imgview"
                    src="@/assets/pc/Login/4.png"
                  />
                </div>
                <div
                  class="pboxviews"
                  v-if="detailsVisible == index && markList.length == 0"
                >
                  View Details<img
                    class="imgview"
                    src="@/assets/pc/Login/4.png"
                  />
                </div>
                <div
                  v-if="detailsVisible === index && markList.length > 0"
                  class="pboxboxs"
                >
                  <div class="pboxliboxall">
                    <div v-for="(item, index) in markList" :key="index">
                      <div class="pboxlitit">{{ item.markName }}</div>
                      <div class="pboxlicon">
                        <div class="pboxlileft">Holding cost:</div>
                        <div class="pboxliright">{{ item.holdCost }} U</div>
                      </div>
                      <div class="pboxlicon">
                        <div class="pboxlileft">Holding period:</div>
                        <div class="pboxliright">{{ item.holdTime }}</div>
                      </div>
                      <div class="pboxlicon">
                        <div class="pboxlileft">Holding price:</div>
                        <div class="pboxliright">{{ item.holdPrice }}U</div>
                      </div>

                      <div
                        class="pboxline"
                        v-if="index < markList.length - 1"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Emailsbox">
      <div class="Main-W">
        <div class="Emailli" style="margin-top: 63px">
          <div class="Emaillil Emaillil1">
            <!-- <img src="@/assets/pc/Index/22.png" /> -->
          </div>
          <div class="Emaillir">
            Subscribe to our newsletter to receive the latest updates and
            important announcements.
          </div>
        </div>
        <div class="Emailbtn">
          <el-form
            :model="ruleForm"
            :rules="rules"
            prop="email"
            ref="ruleForm"
            class="demo-dynamic"
            autocomplete="off"
          >
            <el-form-item prop="email">
              <el-input v-model="ruleForm.email" placeholder="Enter your email">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm(ruleForm.email)"
                >Subscribe now</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <div class="footerw">
            <div class="footerleft">
              <img src="@/assets/pc/Index/18.png" />
              <div class="footercon">
                Strong Collaboration, Leading the WEB3 Industry.
              </div>
            </div>
            <div class="footerright">
              <div class="apks">
                <div class="title">FairCrypto Fund Download</div>
                <img src="@/assets/pc/Index/ewm.png" class="erwm" />
                <div class="con">
                  Scan the QR code to download <br />
                  (Only for Android)
                </div>
                <a href="https://www.faircrypto.fund/apk/FairCrypto.apk">
                  <div class="download">Download APK</div></a
                >
              </div>
              <div style="display: flex;margin-top:10px;">
                <a href="https://twitter.com/faircrypt01" target="_blank"
                  ><div class="footerli">X</div></a
                >
                <a href="https://medium.com/@faircrypto" target="_blank"
                  ><div class="footerli">Medium</div></a
                >
                <!-- <div class="footerli">Youtube</div> -->
                <a
                  href="https://mirror.xyz/0x23A1E6cd8196Caad2548240bd662b87Ae7ed2D08/subscribe"
                  target="_blank"
                  ><div class="footerli">Mirror</div></a
                >
              </div>
              <!-- <div class="footerli">Telegram</div> -->
            </div>
          </div>
          <div class="footerb">
            <div class="footerbleft">
              <img src="@/assets/pc/Index/23.png" />2024 - FairCrypto Find, Lnc.
            </div>
            <div class="footerbright" @click="jump('#About1')">
              Invest Email : serve@faircrypto.fund<span
                >Back to top<img src="@/assets/pc/Index/19.png"
              /></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubStr, goPAGE } from "@/utils/utils";
import Login from "../../views/pc/Login/Login.vue";
import Logout from "../../views/pc/Login/Logout.vue";
import Signup from "../../views/pc/Login/Signup.vue";
import Resignup from "../../views/pc/Login/Resignup";
import Record from "../../views/pc/Login/Record.vue";
import Bind from "../../views/pc/Login/Bind.vue";
import Note from "../../views/pc/Login/Note.vue";
import {
  GetEmail,
  SendEmail,
  GetProductList,
  GetInfo,
  GetTranstionList,
  GettProduct,
} from "@/assets/server/api.js";
const echarts = require("echarts");
import axios from "axios";
export default {
  props: {
    duration: {
      //滚动时长
      type: Number,
      default: 4000,
    },
    vertical: {
      //是否纵向
      type: Boolean,
      default: false,
    },
  },
  name: 'Message',
  props: {
    message: {
      type: String,
      default: 'Important update, please click it!'
    },
    duration: {
      type: Number,
      default: 15 // 动画持续时间（秒）
    }
  },
  computed: {
    marqueeStyle() {
      return {
        animationDuration: `${this.duration}s`
      };
    }
  },
  watch: {
    $route: {
      handler: function (to, form) {
        // if (to.path === "/Index") {
        //  console.log(111);
        if (localStorage.getItem("email") == null) {
          if (to.query.userEmail !== undefined) {
            this.userEmail = getSubStr(to.query.userEmail, 0, 4);
          }
          this.userEmail = null;
        } else {
          this.userEmail = getSubStr(localStorage.getItem("email"), 0, 4);
          console.log(this.userEmail);
        }
        // }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      relist: [],
      pageNum: 1,
      total: null,
      xprlAddress: "",
      coinType: "",
      donationAddress: "",
      listitems: [], // Assuming these are your items
      markList: [],
      detailsVisible: null,
      debounceTimeout: null,
      rflog: false,
      testflog: false,
      isBindAddress: "",
      jwtToken: "",
      userEmail: "",
      userId: "",
      coinTxHash: "", //捐赠hash
      txHash: "", //交易hash
      lflog: false, //退出登录
      flogs: false,
      flogs1: true,
      flog: false,
      flogb: false,
      flogc: false, //重置密码
      bflog: false,
      flog1: false,
      isVisible: false, // 初始时为true，表示元素可见
      activeTab: 0, // 默认激活的选项卡的索引
      tabs: [
        { title: "Signature NFTs", content: "Content of Tab 1" },
        { title: "Regular NFTs", content: "Content of Tab 2" },
      ],
      imglogo: require("@/assets/m/Index/xia1.png"),
      imgloga: require("@/assets/m/Index/shang1.png"),
      ruleForm: { email: "" },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            // message: "Please input email",
            trigger: "blur",
          },
        ],
      },
      testflog1: false,
      IMgUrl: "",
      W: document.body.clientWidth + "px",
      list1: [
        { ImgUrl: require("@/assets/pc/indexpic/foot1.png"), name: "img" },
        { ImgUrl: require("@/assets/pc/indexpic/foot2.png"), name: "img1" },
        { ImgUrl: require("@/assets/pc/indexpic/foot3.png"), name: "img2" },
        { ImgUrl: require("@/assets/pc/indexpic/foot4.png"), name: "img3" },
        { ImgUrl: require("@/assets/pc/indexpic/foot5.png"), name: "img4" },
        { ImgUrl: require("@/assets/pc/indexpic/foot6.png"), name: "img5" },
      ],
      timer: null,
      animate: false,
      list: [
        {
          name: "About",
        },
        {
          name: "Investment Direction",
        },
        {
          name: "Investment Process",
        },
        {
          name: "NFT Plan",
        },
        {
          name: "Participation Avenues",
        },
        {
          name: "Foundation",
        },
      ],
      id: "", //设置下拉框是否显示
      clientId: "", //设置wallet页面导航栏颜射
      borId: "",
      index: 0,
      form: {
        content: "", //介绍
        fullName: "",
        email: "",
      },
      rules: {
        // 第一部分效验开始
        fullName: [
          {
            required: true,
            message: "This field is required.",
            trigger: "blur",
          },
          { min: 1, max: 10, message: " Less than 50 bytes", trigger: "blur" },
        ],

        email: [
          {
            required: true,
            type: "email",
            message: "Please fill this in email",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: " Less than 100 bytes",
            trigger: "blur",
          },
        ],

        content: [
          {
            required: true,
            message: "This field is required.",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: " Less than 1000 bytes",
            trigger: "blur",
          },
        ],

        // 第一部分效验结束
      },
      widthPre: "",
      percentage: 10,
      percentagea: 10,
      percentageb: 10,
      percentagec: 10,
      percentaged: 10,
      customColor: "#0B27F1",
      btnShow: false,
      isSubmitting: false,
    };
  },
  components: {
    Login,
    Signup,
    Bind,
    Record,
    Resignup,
    Logout,
    Note,
  },
  // 计算属性

  created() {
    this.timer = setInterval(this.scroll, this.duration);
    this.userEmail = localStorage.getItem("email");
    this.xprlAddress = localStorage.getItem("xprl");
    this.donationAddress = localStorage.getItem("donation");
    this.userId = localStorage.getItem("userId");
    this.coinType = localStorage.getItem("coinTypes");
  },
  mounted() {
    this.GetProductLists();
    if (
      this.userEmail !== "" ||
      this.userEmail !== null ||
      this.userEmail !== undefined
    ) {
      this.userEmail = localStorage.getItem("email");
      // console.log(this.userEmail);
      this.userId = localStorage.getItem("userId");
      this.jwtToken = localStorage.getItem("jwtToken");
      this.isBindAddress = localStorage.getItem("isBindAddress");
      // console.log(this.isBindAddress);
      // console.log(this.userId);
      if (this.userEmail !== null) {
        this.userEmail = getSubStr(this.userEmail, 0, 4);
      }
    }
    window.addEventListener("scroll", this.scrollFn, false);

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        const newColorScheme = e.matches ? "dark" : "light";
        console.log(newColorScheme);
      });

    // window.addEventListener("scroll", this.scrollFna, false);
  },
  destroyed() {},
  methods: {
    formattedDate(val) {
      const date = new Date(val);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    async GettProductdatails() {
      const params = {
        productId: this.pageNum,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GettProduct(formData);
    },
    async GetProductLists() {
      const params = {
        pageNum: this.pageNum,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetProductList(formData);
      // console.log(data);
      // console.log(data);
      this.listitems = data.result.list;
      // console.log(this.listitems);
    },
    hashsubmit1() {
      this.$message("Coming Soon");
    },
    async hashsubmit() {
      // 检查是否有空的哈希值
      if (this.coinTxHash === "" || this.txHash === "") {
        this.$message("The Hash cannot be empty");
        return false;
      }

      // 如果已经在提交，则不重复提交
      if (this.isSubmitting) return;

      // 设置提交状态
      this.isSubmitting = true;

      // 准备请求参数
      const params = {
        userId: localStorage.getItem("userId"),
        coinTxHash: this.coinTxHash,
        txHash: this.txHash,
      };
      const formData = new FormData();
      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          formData.append(key, params[key]);
        }
      }

      try {
        // 发送请求
        let data = await GetInfo(formData);

        // 模拟延迟以显示加载动画
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // 处理请求结果
        if (data.code === 200) {
          this.$message(data.result);
          this.coinTxHash = "";
          this.txHash = "";
        } else {
          this.$message(data.result);
        }
      } catch (error) {
        // 处理请求错误
        this.$message("Submission failed. Please try again.");
      } finally {
        // 无论请求成功还是失败，都重置提交状态
        this.isSubmitting = false;
      }
    },
    // async hashsubmit() {
    //   // let config = {
    //   //   headers: {
    //   //     "Content-Type": "application/json",
    //   //     jwtToken: this.jwtToken,
    //   //   },
    //   // };
    //   if (this.coinTxHash == "" || this.txHash == "") {
    //     this.$message("The Hash cannot be empty");
    //     return false;
    //   }
    //   if (this.isSubmitting) return;
    //   this.isSubmitting = true;
    //   const params = {
    //     userId: localStorage.getItem("userId"),
    //     coinTxHash: this.coinTxHash,
    //     txHash: this.txHash,
    //   };
    //   const formData = new FormData();
    //   const item = params;
    //   for (const key in item) {
    //     if (Object.hasOwnProperty.call(item, key)) {
    //       formData.append(key, item[key]);
    //     }
    //   }
    //   let data = await GetInfo(formData);
    //   // let data = await GetInfo(formData,config);
    //   // 模拟请求
    //   setTimeout(() => {
    //     // 假设请求失败，模拟处理失败逻辑

    //     if (data.code == 200) {
    //       this.$message(data.result);
    //       this.coinTxHash = "";
    //       this.txHash = "";
    //       // 请求成功后的逻辑
    //       this.isSubmitting = false;
    //     } else {
    //       // 请求失败后的逻辑
    //       this.$message(data.result);
    //       this.isSubmitting = false; // 重置 isSubmitting 状态
    //     }
    //   }, 2000); // 2秒的模拟延迟
    //   // if (data.code == 200) {
    //   //   this.$message(data.result);
    //   //   this.coinTxHash = "";
    //   //   this.txHash = "";
    //   //   setTimeout(() => {
    //   //     // 提交逻辑在这里
    //   //     // 提交完成后，将 isSubmitting 重置为 false
    //   //     this.isSubmitting = false;
    //   //   }, 2000); // 2秒的模拟延迟
    //   // } else {

    //   //   this.$message(data.result);
    //   //   this.isSubmitting = true;
    //   // }
    // },
    donation(val) {
      // console.log(val);
      this.donationAddress = val;
    },
    coinTypes(val) {
      this.coinType = val;
    },
    xprl(val) {
      //console.log(val);
      this.xprlAddress = val;
    },
    isBind(val) {
      this.isBindAddress = val;
      // console.log(this.isBindAddress);
    },
    email(val) {
      this.userEmail = val;
      this.testflog = true;
      //console.log(this.userEmail);
    },
    fflog(val) {
      this.flogc = val;
    },
    repwd(val) {
      //   console.log("接受重置repwd的值", val);
      this.flogc = val;
    },
    back() {
      this.flogc = false;
    },
    async recordlist() {
      this.rflog = true;
      const params = {
        userId: localStorage.getItem("userId"),
        pageNum: this.pageNum,
        pageSize: 10,
      };
      //  console.log(this.userId);
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetTranstionList(formData);
      //  console.log(data);
      this.total = data.result.count;
      this.relist = data.result.list;
    },
    Exits() {
      this.lflog = true;
    },
    bindclick() {
      this.bflog = true;
    },
    showaddressbox() {
      // console.log(2323);
      // console.log(this.testflog);
      this.testflog = true;
    },
    hideaddressbox() {
      this.testflog = false;
    },
    // toggleDetails(index) {
    //   // this.flogs = true;
    //   // this.flogs1 = false;
    // },
    // hidetoggleDetails() {
    //   this.detailsVisible = null;
    // },
    async toggleDetails(index) {
      if (this.detailsVisible === index) {
        this.detailsVisible = null;
      } else {
        const params = {
          productId: this.listitems[index].productId,
          pageNum: this.pageNum,
          pageSize: 10,
        };

        const formData = new FormData();
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            formData.append(key, params[key]);
          }
        }

        try {
          const data = await GettProduct(formData);
          this.markList = data.result.markList;
          for (let i = 0; i < this.markList.length; i++) {
            this.markList[i].holdTime = this.formattedDate(
              this.markList[i].holdTime
            );
          }
          //  console.log(this.markList);
          // Set the detailsVisible after data has been fetched and processed
          this.detailsVisible = index;
        } catch (error) {
          console.error("Error fetching product details:", error);
        }
      }
    },

    debounceToggleDetails(index) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.toggleDetails(index);
      }, 100);
    },
    hidetoggleDetails() {
      this.detailsVisible = null;
    },
    detailsClass(index) {
      return this.detailsVisible == index && this.markList.length == 0
        ? "pboxlibox"
        : "pboxlibox1";
    },
    // formattedDate(date) {
    //   // Implement your date formatting logic here
    //   return date;
    // },

    update() {
      this.bflog = true;
    },
    signups(val) {
      // console.log(val);
      this.flogb = val;
    },
    logouts(val) {
      this.lflog = val;
      // this.flog = true;
      //  console.log(this.lflog);
    },
    loginflog(val) {
      //   console.log("接受login的值", val);
      this.flog = val;
    },
    bloginflog(val) {
      this.bflog = val;
    },
    bloflog(val) {
      this.rflog = val;
    },
    login() {
      // console.log("登录");
      // console.log(this.flog);
      this.flog = true;
    },
     noteClick(val){
         this.rflog = val;
     },
    toggleVisibility() {
      // 切换isVisible的值来控制元素的显示和隐藏
      this.isVisible = !this.isVisible;
    },
    showTestbox() {
      // alert(11);
      this.testflog1 = true;
    },
    showTestbox1() {
      this.testflog1 = true;
    },
    hideTestbox1() {
      this.testflog1 = false;
    },
    getInfo() {
      if (
        this.form.fullName.length >= 1 &&
        this.form.email.length >= 1 &&
        this.form.content.length >= 1
      ) {
        this.btnShow = true;
      } else {
        this.btnShow = false;
      }
    },
    format(percentage) {
      return percentage === 100 ? "100%" : `${percentage}%`;
    },
    scrollFn() {
      let page = document.body.scrollHeight;
      let client = document.documentElement.clientHeight;
      let comend = page - client;
      let scrTop = document.documentElement.scrollTop;
      this.percentage = Number(Math.round((scrTop / comend) * 10000) / 10);
      if (this.percentage > 100) {
        this.percentage = 100;
      }
      this.percentagea =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 280;
      this.percentageb =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 290;
      this.percentagec =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 300;
      this.percentaged =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 310;

      if (this.percentagea >= 100) {
        this.percentagea = 100;
      } else if (this.percentagea <= 0) {
        this.percentagea = 10;
      }

      if (this.percentageb >= 100) {
        this.percentageb = 100;
      } else if (this.percentageb <= 0) {
        this.percentageb = 10;
      }
      if (this.percentagec >= 100) {
        this.percentagec = 100;
      } else if (this.percentagec <= 0) {
        this.percentagec = 10;
      }
      if (this.percentaged >= 100) {
        this.percentaged = 100;
      } else if (this.percentaged <= 0) {
        this.percentaged = 10;
      }
    },
    jump(id) {
      this.shows1 = false;
      var height = document.body.clientHeight;

      var aa = document.querySelector(id);
      // aa.style.backgroundColor="red";
      setTimeout(function () {
        document.querySelector(id).scrollIntoView(true);
      }, 500);
      aa.scrollTo(0, height);
      document.querySelector(id).scrollIntoView(true);
      document.querySelector(id).scrollIntoView();
    },
    Home() {
      this.Scolor = "";
      this.$router.push("/pc/Index");
    },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        this.list.push(this.list.shift()); //删除数组的第一个元素并添加到数组的最后一项
        this.animate = false; //滑动完成后取消过渡动画，实现无缝滚动
      }, this.duration / 2); //滑动item项必须要在每次轮播开始前,所以时间必须比duration短
    },
    async submitForm(formName) {
      // console.log(formName);
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (formName != "") {
        if (formName != "" && !regEmail.test(formName)) {
          this.$message({
            message: "Email must be formatted correctly",
            type: "error",
          });
          this.ruleForm.email = "";
        } else {
          let formData = new FormData();
          let params = {
            email: this.ruleForm.email,
          };
          //  console.log("params", params);
          let item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          // console.log(formData);
          let data = await GetEmail(formData);
          //console.log(data);
          if (data.code == 200) {
            this.$message({
              showClose: true,
              message: "Mailbox subscription succeeded",
              type: "success",
            });
          } else {
            this.$message({
              message: data.result,
              type: "error",
            });
            return false;
          }

          this.ruleForm.email = "";
        }
      } else {
        this.$message({
          message: "Please enter your e-mail address",
          type: "error",
        });
      }

      // this.$refs[formName].validate((valid) => {
      //   console.log(valid);
      //   if (valid) {
      //     alert("submit!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
  },
};
</script>
<style lang="less">
@font-face {
  font-family: "Poppins-ExtraBold";
  src: url("../../assets/font/Poppins-ExtraBold.ttf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Poppins-Regular";
  src: url("../../assets/font/Poppins-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Poppins-SemiBold Italic";
  src: url("../../assets/font/Poppins-SemiBoldItalic.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Poppins-SemiBold";
  src: url("../../assets/font/Poppins-SemiBold.ttf");
  font-weight: normal;
  font-style: normal;
}
.el-input__inner,
.el-textarea__inner {
  height: 28px;
  font-size: 24px;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #000000;

  line-height: 28px;
}
.el-textarea__inner {
  padding-top: 24px;
}

@media (prefers-color-scheme: dark) {
  background: #000000;
}
.homes {
  width: 100%;
  background: #000000;

  height: 68px;
  top: 0;
  left: 0;
  width: 100%;
  line-height: 68px;
  z-index: 100;
  zoom: 1;
  position: sticky;
  .home-W {
    width: 1560px;
    height: 68px;
    margin: 0 auto;
    display: flex;
    // justify-content: space-between;
    background: #000000;
    .logoall {
      display: flex;
      .logo {
        flex: 0 0 20%;
        width: 300px;
        padding: 16px 0;
        .logo_all {
          width: 190px;
          display: flex;
          cursor: pointer;
          .Home_logo {
            flex: 0 0 75%;
          }
          img {
            flex: 0 0 25%;
            width: 167px;
            // height: 29px;
            margin-right: 10px;
            margin-top: 4px;
          }

          line-height: 28px;
        }
      }
      .menu {
        // width: 1300px;
        // border: 1px solid red;
        margin-left: 60px;

        ul {
          display: flex;
          .signtop {
            width: 67px;
            height: 65px;
            // border: 1px solid red;
            position: relative;
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 13px;
            color: #000;
            z-index: 9999999999;
            // background: #ffffff;

            // border-radius: 109px 109px 109px 109px;
            // cursor: pointer;
            .sign1 {
              color: #fff;
            }
            .sign {
              position: absolute;
              width: 67px;
              height: 25px;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 67px;
              height: 25px;
              background: #ffffff;
              border-radius: 109px 109px 109px 109px;
              span {
                position: absolute;
                top: -20px;
                left: 12px;
              }
            }
            .addressbox {
              position: absolute;
              top: 60px;
              right: 0px;
              cursor: default;

              background: #151515;
              border-radius: 10px 10px 10px 10px;
              .boxli {
                width: 300px;
                margin: 0 auto;
                .boxlitit {
                  font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 14px;
                  color: rgba(255, 255, 255, 0.6);
                  height: 21px;
                }
                .boxlicon {
                  font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 13px;
                  height: 21px;
                  margin-top: 6px;
                  color: #ffffff;
                  img {
                    width: 18px;
                    height: 18px;
                    margin-top: 21px;
                    cursor: pointer;
                  }
                  input {
                    border: none;
                    border-bottom: 1px solid #5b5b5b;
                    height: 29px;
                    width: 319px;
                    font-family: Poppins, Poppins;
                    font-weight: 400;
                    font-size: 14px;
                    color: #ffffff;
                  }
                }
              }
              .boxlis {
                margin-top: 26px;
              }
              .boxbind {
                display: flex;
                .exit {
                  width: 58px;
                  height: 28px;
                  line-height: 28px;
                  text-align: center;
                  background: #2b2b2b;
                  border-radius: 81px 81px 81px 81px;
                  font-family: Poppins, Poppins;
                  font-weight: 500;
                  font-size: 13px;
                  color: #3cf6f0;
                  margin-top: 44px;
                  margin-left: 97px;
                  cursor: pointer;
                }
                .bind {
                  width: 157px;
                  height: 28px;
                  line-height: 28px;
                  background: #3cf6f0;
                  border-radius: 81px 81px 81px 81px;
                  font-family: Poppins, Poppins;
                  font-weight: 500;
                  font-size: 13px;
                  color: #151515;
                  text-align: center;
                  margin-top: 44px;
                  margin-left: 18px;
                  cursor: pointer;
                }
              }

              .record {
                height: 21px;
                font-family: Poppins, Poppins;
                font-weight: 400;
                font-size: 14px;
                color: #3cf6f0;
                line-height: 21px;
                margin-left: 30px;
                cursor: pointer;
                margin-top: 6px;
              }
              .submit1 {
                width: 103px;
                height: 28px;
                line-height: 28px;
                border-radius: 81px 81px 81px 81px;
                cursor: pointer;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 13px;
                color: #151515;
                text-align: center;
                margin-left: 361px;
                background: #a1a1a1;
                margin-top: 10px;
              }
              .submit {
                width: 103px;
                height: 28px;
                line-height: 28px;
                background: #3cf6f0;
                border-radius: 81px 81px 81px 81px;
                cursor: pointer;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 13px;
                color: #151515;
                text-align: center;
                margin-left: 361px;
                img {
                  width: 30px;
                  height: 30px;
                }
                /* 旋转动画 */
                @keyframes spin {
                  0% {
                    transform: rotate(0deg);
                  }
                  100% {
                    transform: rotate(360deg);
                  }
                }

                /* 加载动画的样式 */
                .loader {
                  border: 4px solid #f3f3f3;
                  border-top: 4px solid #3498db;
                  border-radius: 50%;
                  width: 20px;
                  //  background: url(../../assets/pc/Index/loading.webp) no-repeat center;
                  height: 20px;
                  animation: spin 2s linear infinite;
                  display: none; /* 默认隐藏 */
                }
              }
              /* 提交按钮禁用状态样式 */
              .submit.disabled {
                pointer-events: none;
                opacity: 0.6;
              }
              .hidden {
                display: none;
              }
              .Reminder {
                margin-left: 30px;
                margin-top: -20px;
                .Remindertit {
                  font-family: Poppins, Poppins;
                  font-weight: 500;
                  font-size: 14px;
                  color: #ffffff;
                  height: 40px;
                }
                .Remindercon {
                  margin-top: 4px;
                  width: 436px;
                  height: 42px;
                  font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 14px;
                  color: #a1a1a1;
                  line-height: 21px;
                }
                .Remindercon1 {
                  height: 30px;
                  font-family: Poppins, Poppins;
                  font-weight: 500;
                  font-size: 20px;
                  color: #3cf6f0;
                  line-height: 30px;
                  margin-top: 25px;
                  margin-left: 201px;
                  cursor: pointer;
                }
              }
            }
            .addressbox1 {
              width: 360px;
              height: 217px;
            }
            .addressbox2 {
              width: 496px;
              height: 536px;
              .boxli {
                width: 436px;
              }
              .hashbox {
                width: 436px;
                height: 168px;
                padding: 0px;
                background: #000000;
                border-radius: 5px 5px 5px 5px;
                margin: 0 auto;
                margin-top: 32px;
                .boxli {
                  // border:1px solid red;
                  margin: 0px;
                  // height: 80px;
                  // line-height: ;
                  padding: 0px;
                  .boxlitit {
                    font-family: Poppins, Poppins;
                    font-weight: 400;
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.6);
                    // height: 21px;
                  }
                  .boxlicon {
                    font-family: Poppins, Poppins;
                    font-weight: 400;
                    font-size: 13px;
                    height: 21px;
                    // margin-top: 6px;
                    color: #ffffff;
                    img {
                      width: 18px;
                      height: 18px;
                      margin-top: 21px;
                      cursor: pointer;
                    }
                    input {
                      border: none;
                      border-bottom: 1px solid #5b5b5b;
                      height: 29px;
                      width: 406px;
                      font-family: Poppins, Poppins;
                      font-weight: 400;
                      font-size: 14px;
                      color: #ffffff;
                    }
                  }
                }
                .boxlis {
                  width: 406px;
                  margin: 0 auto;
                  margin-top: 25px;
                }
              }
            }
          }

          li {
            // flex: 1;

            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 15px;
            color: #ffffff;
            height: 65px;
            line-height: 65px;
            margin-right: 34px;

            cursor: pointer;

            // padding: 20px 0 0 0;
            p {
              //  border: 1px solid red;
              // width: 115px;
              height: 65px;
              line-height: 65px;
              text-align: right;
              // line-height: 24px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 15px;
              color: #ffffff;
              // i {
              //   margin-left: 8px;
              // }
              img {
                width: 14px;
                height: 14px;
                margin-top: 26px;
                margin-left: 4px;
              }
            }
            .menubox {
              // border: 1px solid red;
              a {
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 15px;
                color: #ffffff;
              }

              .menuboxli {
                //margin-left: 16px;
                height: 23px;
                line-height: 23px;
                margin-top: 8px;
              }
              .menuboxli:hover {
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 15px;
                color: #3cf6f0;
              }
            }
            .pclas {
              // margin-left: 18px;
            }
          }
        }
      }
    }
  }
}

.marquee-container {
  width: 80%;
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0); /* 黑色，50% 透明度 */
  padding: 5px 0;
  position: relative;
}

.marquee-content {
  display: inline-block;
  padding-left: 100%;
  animation: marquee linear infinite;
  color: #ffffff;
  font-weight: bold;
}
.marquee-message{
    width: 505px;
    height: 47px;
    text-align: center;
    background: rgba(255,255,255,0.16);
    border-radius: 6px 6px 6px 6px;
    vertical-align: middle;
    display: flex;
    justify-content: center;
    align-items: center;
span{
    font-weight: 500;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 35px;
    font-style: normal;
    text-align: center;
    vertical-align: middle;
}
img{
    width: 32px;
    height: 33px;
    text-align: center;
    vertical-align: middle;
}
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.Home {
  width: 410px;
  padding-bottom: 10px;
  display: inline-block;
  font-size: 16px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 530;
  color: rgba(255, 255, 255, 0.6000000238418579);
  border-bottom: 1px solid #4d4d4d;
  padding-left: 10px;
}
.active {
  transition: all 0.5s;
  height: 225px;
  box-shadow: 0px 113px 100px 1px rgba(0, 0, 0, 0.4000000059604645);
}
.actives:hover {
  p {
    color: #cd60d9 !important;
  }
  .iconfont {
    display: inline-block;
    transition: all 0.5s;
    transform: rotate(180deg) !important ;
  }
}

.swiper_banner {
  width: 100%;
  background: #fff;
  padding-top: 325px;
  .Main-W {
    width: 1320px;
    margin: 0 auto;
    background: #fff;
    .swiper-container {
      width: 100%;
      height: 91px;
      overflow: hidden;
      margin-bottom: 142px;
      .swiper-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        .swiper-slide {
          width: 275px;
          height: 91px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 50px;
          // img{
          //   width: 275px;
          //   // height: 91px;
          // }
          .img {
            width: 275px;
            height: 91px;
            // margin-left: 100px;
          }
          .img1 {
            width: 272px;
            height: 53px;
          }
          .img2 {
            width: 312px;
            height: 47px;
          }
          .img3 {
            width: 272px;
            height: 65px;
          }
          .img4 {
            width: 60px;
            height: 65px;
            margin-left: 100px;
            margin-right: 100px;
          }
          .img5 {
            width: 186px;
            height: 66px;
          }
        }
      }
    }
  }
}

#About1 {
  background: #000;
  width: 100%;
  height: 1012px;
  margin: 0 auto;
  // padding-top: 68px;
  .Main-W {
    width: 1560px;
    margin: 0 auto;
    background: #000;
    .Aboutbg {
      background: url(../../assets/pc/Index/banner.png) center/cover no-repeat;
      width: 1560px;
      height: 1013px;
      position: relative;
      .Aboutitle {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        left: 227px;
        top: 307px;
      }
      .Aboutcon {
        position: absolute;
        top: 355px;
        font-family: Poppins-ExtraBold;
        font-weight: 800;
        font-size: 100px;
        color: #ffffff;
        left: 146px;
        span {
          filter: blur(4px);
        }
      }
      .Aboutcon1 {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        top: 629px;
        left: 1170px;
      }
      .Aboutbotm {
        display: flex;
        position: absolute;
        bottom: 45px;
        width: 100%;
        justify-content: space-between;
        .Aboutbotml {
          font-family: Poppins-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
        }
        .Aboutbotmr {
          img {
            width: 55px;
            height: 55px;
          }
        }
      }
    }
  }
}
#About {
  background: #000;
  height: 115px;
}
.About {
  // padding-top: 191px;
  background: #000;
  width: 100%;
  height: 935px;
  .Main-W {
    width: 1560px;
    margin: 0 auto;
    background: #000;
    .aboutMission {
      font-family: Poppins-SemiBold Italic;
      font-weight: 600;
      font-size: 50px;
      color: #ffffff;
      // margin-top: 115px;
      img {
        width: 12px;
        height: 10px;
        margin-top: 44px;
        margin-left: 6px;
      }
    }
    .Missionbox {
      margin-top: 88px;
      // border: 1px solid red;
      .Missionboxli {
        display: flex;
        justify-content: space-between;
        margin-bottom: 112px;
        .Missionboxlil {
          .Missionboxtit {
            font-family: Poppins-SemiBold;
            font-weight: 600;
            font-size: 40px;
            color: #ffffff;
          }
          .Missionboximg {
            margin-top: -16px;
            .img1 {
              width: 267px;
              height: 54px;
            }
            .img2 {
              width: 241px;
              height: 61px;
            }
            .img3 {
              width: 222px;
              height: 58px;
            }
          }
        }
        .Missionboxlir {
          .Missionboxlirtit {
            height: 36px;
            font-family: Poppins-SemiBold;
            font-weight: 600;
            font-size: 24px;
            color: #3cf6f0;
            line-height: 36px;
          }
          .Missionboxlilcon {
            margin-top: 16px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            line-height: 27px;
            word-spacing: 0px;
          }
        }
      }
    }
  }
}

#Mission {
  background: #000;
  height: 115px;
}
.Mission {
  background: #000;
  width: 100%;
  height: 1020px;

  .Main-W {
    width: 1560px;
    background: #000;
    margin: 0 auto;
    // padding-bottom: 128px;
    .Direction {
      font-family: Poppins-SemiBold Italic;
      font-weight: 600;
      font-size: 50px;
      color: #ffffff;
      // margin-top: 115px;
      img {
        width: 12px;
        height: 10px;
        margin-top: 44px;
        margin-left: 6px;
      }
    }
    img {
      width: 1559px;
      height: 681px;
      margin-top: 97px;
    }
  }
}
#Service {
  background: #000;
  height: 115px;
}
.Service {
  background: #000;
  width: 100%;
  height: 1060px;
  .serve {
    width: 100%;
    background: #000;
    .Main-W {
      width: 1560px;
      margin: 0 auto;
      .Process {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 50px;
        color: #ffffff;
        // margin-top: 115px;
        img {
          width: 12px;
          height: 10px;
          margin-top: 44px;
          margin-left: 6px;
        }
      }
      .Processall {
        margin-top: 37px;
        //position: relative;
        .Process1 {
          display: flex;
          // position: absolute;
          // left: 50%;
          margin-left: 748px;
          img {
            width: 68px;
            height: 67px;
          }
          span {
            font-family: Poppins, Poppins;
            font-weight: 700;
            font-size: 24px;
            color: #ffffff;
            margin-left: 19px;
            margin-top: 8px;
          }
        }
        .Processline {
          // position: absolute;
          // left: 52.1%;
          // top: 67px;
          // border: 2px solid #BDBDBD;
          margin-left: 782px;
          height: 97px;
          width: 1px;
          background: #bdbdbd;
        }
        .Processline1 {
          margin-left: 782px;
          height: 50px;
          width: 1px;
          background: #bdbdbd;
        }
        .Processline2 {
          margin-left: 782px;
          height: 40px;
          width: 1px;
          background: #bdbdbd;
          margin-top: -10px;
        }
        .jian {
          width: 17px;
          height: 17px;
          margin-left: 774px;
          margin-top: -4px;
        }
        .Process2 {
          display: flex;
          // position: absolute;
          // left: 26.5%;
          // top: 160px;
          //  align-content: center;

          margin-left: 376px;
          img {
            width: 68px;
            height: 67px;
            // margin-left: 382px;
            // margin-left: 748px;
          }
          div {
            width: 353px;
            height: 36px;
            font-family: Poppins, Poppins;
            font-weight: 700;
            font-size: 24px;
            color: #ffffff;
            margin-right: 19px;
            margin-top: 12px;
            text-align: right;
          }
        }
        .Process2a {
          // position: absolute;
          // left: 50%;
          // top: 300px;
          margin-left: 748px;
          width: 68px;
          height: 67px;
        }
        .Process3 {
          display: flex;
          .box {
            margin-left: 220px;
            .boxs {
              width: 166px;
              height: 49px;
              line-height: 49px;
              background: #00cdc6;
              border-radius: 197px 197px 197px 197px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 18px;
              color: #000000;
              text-align: center;
            }
            .boxx {
              margin-left: 83px;
              .boxxlinea {
                height: 50px;
                width: 1px;
                background: #bdbdbd;
              }
              img {
                width: 17px;
                height: 17px;
                margin-left: -8px;
              }
              .boxxlinea1 {
                height: 64px;
                width: 1px;
                background: #bdbdbd;
                //background: red;
              }
            }
          }
          .boxline1 {
            width: 76px;
            height: 1px;
            background: #bdbdbd;
            // margin-top: -10px;
            margin-top: 24px;
            margin-left: 4px;
          }
          .boxleft {
            width: 17px;
            height: 17px;
            margin-top: 16px;
          }
          .boxline2 {
            width: 76px;
            height: 1px;
            background: #bdbdbd;
            // margin-top: -10px;
            margin-top: 24px;
            // margin-left: 4px;
          }
          .boxline3 {
            width: 56px;
            height: 1px;
            background: #bdbdbd;
            // margin-top: -10px;
            margin-top: 24px;
            margin-left: 4px;
          }
          .boxline4 {
            width: 56px;
            height: 1px;
            background: #bdbdbd;
            // margin-top: -10px;
            margin-top: 24px;
            margin-left: 4px;
            // background: red;
          }
          .boxtit {
            font-family: Poppins, Poppins;
            font-weight: 700;
            font-size: 24px;
            color: #ffffff;
            margin-top: 10px;
            margin-left: 4px;
          }
          .boxright {
            width: 17px;
            height: 17px;
            margin-top: 16px;
          }
          .box1 {
            margin-top: -12px;
            .box1s {
              width: 138px;
              height: 76px;
              background: #00cdc6;
              border-radius: 31px 31px 31px 31px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 18px;
              color: #000000;
              text-align: center;
              padding-top: 12px;
            }
            .box1x {
              margin-left: 69px;
              .box1xline {
                height: 50px;
                width: 1px;
                background: #bdbdbd;
              }
              img {
                width: 17px;
                height: 17px;
                margin-left: -8px;
              }
              .box1xline1 {
                height: 50px;
                width: 1px;
                background: #bdbdbd;
                // background: red;
              }
            }
          }
        }
        .Process4 {
          display: flex;
          .taep {
            width: 372px;
            height: 72px;
            line-height: 72px;
            background: #fff;
            // background: #808080;
            border-top: 4px solid #808080;
            border-left: 4px solid #808080;
            border-bottom: 4px solid #808080;
            border-radius: 197px 0px 0px 197px;
            margin-right: -10px;
            // transform: skewY(-45deg) skewX(135deg);
            .taep1box {
              color: #000000;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 18px;
              color: #000000;
              line-height: 27px;
              margin-top: 16px;
              word-spacing: -2px;
              display: flex;
              span {
                width: 47px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background: #000000;
                border-radius: 99px 99px 99px 99px;

                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                margin-left: 18px;
                margin-right: 5px;
                // padding: 0px 4px;
                // margin-left: 22px;
              }
            }
          }
          .teplinesa {
            width: 8px;
            height: 38px;
            margin-top: 36px;
            background: #000;
            transform: skewY(65deg) skewX(-135deg);
          }
          .teplinesb {
            width: 8px;
            height: 38px;
            margin-top: 36px;
            background: #000;
            transform: skewY(65deg) skewX(-135deg);
          }
          .teplines {
            width: 8px;
            height: 28px;
            margin-top: 26px;
            background: #000;
            transform: skewY(65deg) skewX(-135deg);
          }
          .taep1 {
            width: 282px;
            height: 72px;
            line-height: 72px;
            background: #fff;
            // background: #808080;
            border-top: 4px solid #808080;
            border-right: 4px solid #808080;
            border-bottom: 4px solid #808080;
            border-radius: 0px 197px 197px 0px;
            .taep1box {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 16px;
              color: #000000;
              line-height: 27px;
              margin-top: 6px;
              word-spacing: -2px;
              margin-left: 10px;
            }
            .taep1box1 {
              .line1a {
                height: 48px;
                width: 1px;
                //background: red;
                background: #bdbdbd;
                margin-top: 8px;
                margin-left: 106px;
              }
              .imga1 {
                width: 17px;
                height: 17px;
                margin: 0px;
                margin-left: 98px;
                margin-top: -4px;
              }
              .line2a {
                height: 44px;
                width: 1px;
                background: #bdbdbd;
                margin: 0px;
                margin-top: -62px;
                margin-left: 106px;
              }
            }
            span {
              width: 47px;
              height: 24px;
              line-height: 24px;
              text-align: center;
              background: #000000;
              border-radius: 99px 99px 99px 99px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 16px;
              color: #ffffff;
              padding: 0px 6px;
            }
          }
          .taep2 {
            width: 262px;
            height: 76px;
            background: #00cdc6;
            border-radius: 20px 20px 20px 20px;
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 18px;
            color: #000000;
            text-align: left;
            padding-top: 11px;
            padding-left: 18px;
          }
          .taep3 {
            margin-right: -10px;
            width: 138px;
            height: 109px;
            line-height: 119px;
            background: #fff;
            // background: #808080;
            border-top: 4px solid #808080;
            border-left: 4px solid #808080;
            border-bottom: 4px solid #808080;
            border-radius: 197px 0px 0px 197px;
            margin-left: 18px;
            text-align: center;
            .taepcont {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 16px;
              color: #000000;
              line-height: 27px;
              margin-top: 8px;
              margin-left: 12px;
              span {
                width: 47px;
                height: 24px;
                background: #000000;
                border-radius: 99px 99px 99px 99px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                padding-left: 6px;
                padding-right: 6px;
              }
            }
          }
          .taep44 {
            width: 155px;
            height: 109px;
            border-top: 4px solid #808080;
            background: #fff;
            border-bottom: 4px solid #808080;
            text-align: center;
            .taepcont {
              margin-top: 8px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 16px;
              color: #000000;
              line-height: 27px;
              // margin-left: 16px;
              span {
                width: 47px;
                height: 24px;
                background: #000000;
                border-radius: 99px 99px 99px 99px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                padding-left: 6px;
                padding-right: 6px;
              }
            }
          }
          .taep4 {
            width: 199px;
            height: 109px;
            line-height: 119px;
            background: #fff;
            margin-left: -10px;
            // background: #808080;
            border-top: 4px solid #808080;
            border-right: 4px solid #808080;
            border-bottom: 4px solid #808080;
            border-radius: 0px 197px 197px 0px;
            margin-right: 30px;
            text-align: center;
            .taepcont {
              margin-top: 8px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 16px;
              color: #000000;
              line-height: 27px;
              // margin-left: 16px;
              span {
                width: 47px;
                height: 24px;
                background: #000000;
                border-radius: 99px 99px 99px 99px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                padding-left: 6px;
                padding-right: 6px;
              }
            }
          }
          .taepline {
            width: 40px;
            height: 1px;
            background: #bdbdbd;
            margin-top: 28px;
          }
          img {
            width: 17px;
            height: 17px;
            margin-top: 21px;
            margin-left: -4px;
          }
        }
        .endteap {
          display: flex;
          margin-top: 68px;
          margin-left: 100px;
          .taep5 {
            margin-right: -10px;
            width: 262px;
            height: 72px;
            line-height: 72px;
            background: #fff;
            // background: #808080;
            border-top: 4px solid #808080;
            border-left: 4px solid #808080;
            border-bottom: 4px solid #808080;
            border-radius: 197px 0px 0px 197px;
            margin-left: 68px;
            .taepcont {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 16px;
              color: #000000;
              line-height: 27px;
              margin-top: 8px;
              margin-left: 22px;
              span {
                width: 47px;
                height: 24px;
                background: #000000;
                border-radius: 99px 99px 99px 99px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                padding-left: 6px;
                padding-right: 6px;
              }
            }
          }
          .taep6 {
            width: 290px;
            height: 72px;
            line-height: 72px;
            background: #fff;
            // background: #808080;
            border-top: 4px solid #808080;
            border-right: 4px solid #808080;
            border-bottom: 4px solid #808080;
            border-radius: 0px 197px 197px 0px;
            .taepcont {
              margin-top: 16px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 16px;
              color: #000000;
              line-height: 27px;
              margin-left: 74px;
              span {
                width: 47px;
                height: 24px;
                background: #000000;
                border-radius: 99px 99px 99px 99px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                padding-left: 6px;
                padding-right: 6px;
              }
            }
          }
          .teplines {
            width: 8px;
            height: 28px;
            margin-top: 24px;
            background: #000;
            transform: skewY(65deg) skewX(-135deg);
          }
        }
      }
    }
  }
}
#Stratagem {
  background: #000;
  height: 115px;
}
.Stratagem {
  background: #000;
  width: 100%;
  height: 970px;
  // height: 1724px;
  .Stratagem {
    width: 100%;
    background: #000;
    .Main-W {
      width: 1560px;
      background: #000;
      margin: 0 auto;
      padding-bottom: 128px;
      .NftPlan {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 50px;
        color: #ffffff;
        // margin-top: 115px;
        img {
          width: 12px;
          height: 10px;
          margin-top: 44px;
          margin-left: 6px;
        }
      }
      .NftPlanbox {
        display: flex;
        .NftPlanleft {
          margin-top: 230px;
          margin-left: 247px;
          .Nftimg {
            width: 336px;
            height: 336px;
          }
          .Nftcon {
            margin-top: 30px;
            margin-left: 63px;
            img {
              width: 20px;
              height: 20px;
              margin-right: 8px;
              margin-top: 8px;
            }
            span {
              font-family: Poppins, Poppins;
              font-weight: 600;
              font-size: 24px;
              color: #3cf6f0;
            }
          }
          .Nftcon1 {
            margin-left: 63px;
            margin-top: 13px;
            img {
              width: 20px;
              height: 20px;
              margin-right: 8px;
              margin-top: 8px;
            }
            span {
              font-family: Poppins, Poppins;
              font-weight: 600;
              font-size: 24px;
              color: #f2f2f2;
            }
          }
        }
        .NftPlanright {
          margin-left: 104px;
          margin-top: 160px;
          .Nftli {
            display: flex;
            .Nftlileft {
              // margin-top: 6px;
              .Nftline {
                width: 1px;
                background: #fff;
                margin-left: 3.5px;
                padding-top: 6px;
                padding-bottom: 6px;
              }
              .lineheight {
                height: 131px;
              }
              .lineheight1 {
                height: 103px;
              }
              .lineheight2 {
                height: 158px;
              }
              .Nftdian {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #fff;
                // margin-top: 6px;
              }
            }
            .Nftliright {
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 18px;
              color: #ffffff;
              margin-left: 8px;
              margin-top: -4px;
              span {
                color: #3bfff8;
              }
            }
            .Nftlirighta {
              margin-top: 14px;
              margin-left: 16px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 18px;
              color: #fff;
              line-height: 27px;
              span {
                color: #3bfff8;
              }
            }
          }
        }
      }
    }
  }
}

#Contact {
  background: #000;
  height: 115px;
}
.Contact {
  background: #000;
  // height: 1175px;
  // height: 1080px;
  // padding-bottom: 173px;

  .Main-W {
    width: 1560px;
    margin: 0 auto;
    padding: 0;
    .Foundation {
      font-family: Poppins-SemiBold Italic;
      font-weight: 600;
      font-size: 50px;
      color: #ffffff;
      // margin-top: 115px;
      margin-bottom: 115px;
      img {
        width: 12px;
        height: 10px;
        margin-top: 44px;
        margin-left: 6px;
      }
    }
    .Foundationli {
      display: flex;
      margin-top: 24px;
      .Foundcon {
        width: 46px;
        height: 46px;
        background: #00cdc6;
        border-radius: 50%;
        line-height: 46px;
        text-align: center;
        font-family: Poppins, Poppins;
        font-weight: 900;
        font-size: 24px;
        color: #000000;
      }
      .concontent {
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 24px;
        color: #ffffff;
        margin-top: 6px;
        margin-left: 19px;
      }
      .concontent1 {
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 24px;
        color: #ffffff;
        margin-top: 6px;
        margin-left: 9px;
      }
      .concontent2 {
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 24px;
        color: #ffffff;
        margin-top: 6px;
        margin-left: 30px;
      }
      .img {
        width: 28px;
        height: 28px;
        margin-top: 10px;
        margin-left: 2px;
      }
      .img1 {
        width: 28px;
        height: 28px;
        margin-top: 10px;
        margin-left: 6px;
      }
      .img2 {
        width: 46px;
        height: 46px;
        margin-left: 30px;
        // margin-top: 10px;
      }
    }
    .Foundbox {
      margin-top: 44px;
      display: flex;
      .Foundboxli {
        width: 441px;
        height: 167px;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ffffff;
        margin-right: 50px;
        padding-top: 16px;
        padding-left: 16px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 27px;
        word-spacing: 0px;
      }
      .Foundboxlia {
        width: 451px !important;
      }

      .Foundboxli:hover {
        // background: url();
        background: url("../../assets/pc/Index/21.png") center/cover no-repeat;
        width: 441px;
        height: 167px;
        border: none;
      }
    }
    .Foundboxline {
      margin-top: 48px;
      height: 27px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 18px;
      color: #3cf6f0;
      line-height: 27px;
      text-align: left;
      cursor: pointer;
      // padding-bottom: 120px;
      img {
        width: 18px;
        height: 18px;
        margin-top: 4px;
        margin-left: 2px;
      }
    }
    .Foundboxall {
      margin-top: 20px;

      .tab {
        display: flex;
        width: 252px;
        height: 37px;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #00cdc6;
      }
      button {
        border: none;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 14px;
        // height: 29px;
        // line-height: 29px;
        color: #ffffff;
        word-spacing: 0px;
        width: 119px;
        cursor: pointer;

        margin-left: 8px;
        // margin-right: 11px;
        // margin-left: 24px;
      }
      .active {
        width: 119px;
        height: 29px;
        background: #00cdc6;
        border-radius: 6px 6px 6px 6px;
        text-align: center;
        line-height: 29px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        margin-top: 2px;
        margin-left: 2px;
        word-spacing: 0px;
        padding-left: 12px;
        padding-right: 12px;
        cursor: pointer;
      }
      .tab-content {
        margin-top: 20px;

        .tabcontent {
          width: 354px;
          height: 184px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #00cdc6;
          overflow: hidden;
          .nodata {
            line-height: 184px;
            text-align: center;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 15px;
            color: #ffffff;
          }
          .tabtitle {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            border-bottom: 1px solid rgba(216, 216, 216, 0.5);
            text-align: left;
            margin-left: 16px;
            height: 38px;
            line-height: 38px;
            margin-right: 16px;
          }
          .tabbox {
            overflow-y: auto;
            margin-left: 16px;
            .tabboxli {
              height: 24px;
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              line-height: 24px;
              line-height: 42px;
              margin-top: 8px;
              margin-bottom: 8px;
            }
          }
          /* 设置滚动条的宽度和背景颜色 */
          .tabbox::-webkit-scrollbar {
            width: 0px; /* 对于垂直滚动条，设置宽度 */
            height: 10px; /* 对于水平滚动条，设置高度 */
            background-color: #f9f9f9; /* 滚动条的背景色 */
          }

          // /* 设置滚动条滑块的样式 */
          // .tabbox ::-webkit-scrollbar-thumb {
          //   background-color: #bdbdbd; /* 滑块的颜色 */
          //   border-radius: 5px; /* 滑块的圆角 */
          // }
        }
      }
    }
  }
}

#FoundNft {
  background: #000;
  height: 173px;
}
.FoundNft {
  //  width: 1920px;
  //  width: 1560px;
  margin: 0 auto;
  .FoundNftimg {
    background: url("../../assets/pc/Index/15.png");
    height: 374px;
    background-size: cover;

    // margin: 0 auto;
    // position:fixed;
    // top: 0;
    // left: 0;
    // width:100%;
    // height:100%;
    min-width: 1560px;
    z-index: -10;
    zoom: 1;
    // background-color: #fff;
    // background: url(../img/bg_login.jpg) no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
  }

  //   background-repeat: no-repeat;
  // background-size: contain;
  // background-position: center;
  .Main-W {
    width: 1560px;

    margin: 0 auto;
    .FoundNftbox {
      display: flex;
      .FoundNftleft {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 50px;
        color: #ffffff;
        margin-top: 137px;
        img {
          width: 12px;
          height: 10px;
          margin-top: 44px;
          margin-left: 6px;
        }
      }
      .FoundNftright {
        height: 132px;
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 22px;
        color: #ffffff;
        line-height: 33px;
        margin-top: 110px;
        margin-left: 238px;
      }
    }
  }
}
.Emailsbox {
  background: #000;
  // height: 1080px;
  .Main-W {
    width: 1560px;
    margin: 0 auto;
    background: #000;
    //     .apks {
    //       width: 269px;
    //       height: 398px;
    //       background: url('../../assets/pc/Index/bg.png') no-repeat;
    //       margin-top: 192px;
    //       background-size: cover;
    //       .title {

    //         height: 27px;
    //         font-family: Poppins, Poppins;
    //         font-weight: 800;
    //         font-size: 18px;
    //         color: #ffffff;
    //         line-height: 25px;
    //         text-align: left;
    //         font-style: normal;
    //         text-transform: none;
    //         margin-top: 8px;
    //         margin-left: 10px;
    //       }
    //       .erwm {
    //         width: 210px;
    //         height: 210px;
    //         margin-left:27px;
    //         margin-top: 13px;
    //       }
    //       .con {
    //         height: 42px;
    //         font-family: Poppins, Poppins;
    //         font-weight: 400;
    //         font-size: 14px;
    //         color: #ffffff;
    //         line-height: 21px;
    //         text-align: left;
    //         font-style: normal;
    //         text-transform: none;
    //         margin-left: 27px;
    //         margin-top: 8px;
    //       }
    //       .download {
    //         width: 156px;
    //         height: 50px;
    //         background: #ffffff;
    //         border-radius: 20px 20px 20px 20px;
    //         font-family: Poppins, Poppins;
    // font-weight: 600;
    // font-size: 16px;
    // color: #000000;
    // line-height: 50px;
    // text-align: center;
    // font-style: normal;
    // text-transform: none;
    // margin:0 auto;
    // margin-top: 12px;
    // cursor: pointer;
    //       }
    //     }
    .Emailli {
      display: flex;

      .Emaillil {
        margin-left: 264px;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .Emaillil1 {
        margin-left: 0px;
      }
      .Emaillir {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 22px;
        color: #ffffff;
        line-height: 33px;
        text-align: left;
        margin-left: 11px;
      }
    }
    .Emailtext {
      display: flex;
      margin-left: 265px;
      margin-bottom: 8px;
      .Emailtit {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 24px;
        span {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 16px;
          color: red;
        }
      }
      .Emailcon {
        //height: 24px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-decoration-line: underline;
        text-transform: none;
        margin-left: 16px;
        img {
          width: 26px;
          height: 26px;
        }
      }
    }
    .Emailtext1 {
      display: flex;
      margin-left: 265px;
      margin-bottom: 8px;
      .Emailtit {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 24px;
        width: 284px;
      }
      .Emailcon {
        //height: 24px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        text-align: left;

        font-style: normal;
        text-decoration-line: underline;
        text-transform: none;
        margin-left: 46px;
        img {
          width: 26px;
          height: 26px;
        }
      }
    }
    .Emailbtn {
      // margin-left: 536px;
      .demo-dynamic {
        margin-top: 12px;
        margin-left: 16px;
        display: flex;
        .el-input__inner {
          width: 380px;
          height: 50px;
          border-radius: 20px 20px 20px 20px;
          border: 2px solid #ffffff;

          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          padding: 0 30px;
          background: #000;
        }
        .el-button {
          width: 156px !important;
          height: 50px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          border-radius: 20px 20px 20px 20px;
          background: #fff;

          margin-left: -120px;
        }
      }
    }
    .footer {
      // margin-top: 179px;
      .footerw {
        display: flex;
        justify-content: space-between;
        .footerleft {
          margin-top:189px;
          img {
            width: 168px;
            height: 30px;
          }
          .footercon {
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 3px;
          }
        }
        .footerright {
          .apks {
            width: 269px;
            height: 398px;
            background: url("../../assets/pc/Index/bg.png") no-repeat;
           margin-top:-200px;
            background-size: cover;
            .title {
              height: 27px;
              font-family: Poppins, Poppins;
              font-weight: 800;
              font-size: 18px;
              color: #ffffff;
              line-height: 25px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              padding-top: 15px;
              margin-left: 10px;
            }
            .erwm {
              width: 210px;
              height: 210px;
              margin-left: 27px;
              margin-top: 24px;
            }
            .con {
              height: 42px;
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 14px;
              color: #ffffff;
              line-height: 21px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              margin-left: 27px;
              margin-top: 8px;
            }
            .download {
              width: 156px;
              height: 50px;
              background: #ffffff;
              border-radius: 20px 20px 20px 20px;
              font-family: Poppins, Poppins;
              font-weight: 600;
              font-size: 16px;
              color: #000000;
              line-height: 50px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              margin: 0 auto;
              margin-top: 12px;
              cursor: pointer;
            }
          }
          .footerli {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            margin-right: 40px;
            cursor: pointer;
          }
        }
      }
      .footerb {
        display: flex;
        justify-content: space-between;
        margin-top: 25px;
        .footerbleft {
          img {
            width: 15px;
            height: 15px;
            margin-top: 4px;
            margin-right: 4px;
          }
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 26px;
        }
        .footerbright {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 24px;
          word-spacing: 8px;
          cursor: pointer;
          span {
            margin-left: 41px;
            word-spacing: 0px;
          }
          img {
            width: 16px;
            height: 18px;
            margin-top: 6px;
            margin-left: 5px;
          }
        }
      }
    }
  }
}
#Products {
  background: #000;
  height: 144px;
}
.Products {
  background: #000;
  .Main-W {
    width: 1560px;
    // border: 1px solid red;
    margin: 0 auto;
    background: #000;
    .Process {
      font-family: Poppins-SemiBold Italic;
      font-weight: 600;
      font-size: 50px;
      color: #ffffff;
      margin-bottom: 60px;
      // margin-top: 115px;
      img {
        width: 12px;
        height: 10px;
        margin-top: 44px;
        margin-left: 6px;
      }
    }
    .Productsbox {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;

      .pboxli {
        position: relative;
        margin-right: 34px;
        width: 486px;
        background: linear-gradient(
          180deg,
          rgba(9, 11, 11, 0.02) 0%,
          #090b0b 100%
        );
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #30393a;
        margin-bottom: 40px;
        // .pboxlibox1{
        //   min-height: 440px;
        //   border: 1px solid red;
        // }

        .pboxlibox,
        .pboxlibox1 {
          width: 406px;
          margin: 0 auto;
          min-height: 420px;
          .imgs {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: #fff;
            margin-top: 40px;
          }
          .pboxboxs {
            position: absolute;
            width: 486px;
            background: #090b0b;
            border-radius: 0px 0px 10px 10px;
            border: 1px solid #30393a;
            border-top: none;
            margin-bottom: 40px;
            z-index: 9999999;
            left: -1px;
            // top: 350px;
            padding-bottom: 40px;
            .pboxlibox {
              width: 406px;
              margin: 0 auto;
              .pboxlitit {
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 26px;
                color: #ffffff;
                margin-top: 40px;
                margin-bottom: 14px;
              }
              .pboxlicon {
                display: flex;
                justify-content: space-between;
                .pboxlileft {
                  font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 18px;
                  color: rgba(255, 255, 255, 0.6);
                  height: 27px;
                  line-height: 27px;
                  margin-bottom: 7px;
                }
                .pboxliright {
                  font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 18px;
                  color: #ffffff;
                  height: 27px;
                  line-height: 27px;
                  margin-bottom: 7px;
                }
                // .addrs {
                //   border: 1px solid red;
                //   width: 300px;
                // }
              }
              .pboxline {
                width: 406px;
                height: 0px;
                border: 1px solid #30393a;
                margin-top: 7px;
                margin-bottom: 14px;
              }
            }
          }
          .pboxlitit {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 26px;
            color: #ffffff;
            margin-top: 40px;
            margin-bottom: 14px;
          }
          .pboxlicon {
            display: flex;
            justify-content: space-between;
            .pboxlileft {
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 18px;
              color: rgba(255, 255, 255, 0.6);
              // height: 27px;
              line-height: 27px;
              margin-bottom: 7px;
            }
            .pboxliright {
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 18px;
              color: #ffffff;
              // height: 27px;

              line-height: 27px;
              margin-bottom: 7px;
            }
            .addrs {
              //border: 1px solid red;
              width: 300px;
              word-wrap: break-word;
              text-align: right;
            }
            .pboxlirighta {
              width: 200px; /* 定义容器宽度 */
              text-align: right;
              word-wrap: break-word;
            }
          }
          .pboxline {
            width: 406px;
            height: 0px;
            border: 1px solid #30393a;
            margin-top: 7px;
            margin-bottom: 14px;
          }
          .pboxviews {
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            margin-left: 138px;
            padding-bottom: 18px;
            cursor: pointer;
            .imgview {
              width: 16px;
              height: 16px;
              margin-top: 5px;
              margin-left: 4px;
              cursor: pointer;
            }
          }
          .pboxliboxall {
            width: 406px;
            margin: 0 auto;
            .imgs {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              background: #fff;
              margin-top: 40px;
            }
            .pboxboxs {
              position: absolute;
              width: 486px;
              background: #090b0b;
              border-radius: 0px 0px 10px 10px;
              border: 1px solid #30393a;
              border-top: none;
              margin-bottom: 40px;
              z-index: 9999999;
              left: -1px;
              top: 340px;
              padding-bottom: 40px;
              .pboxlibox {
                width: 406px;
                margin: 0 auto;
                .pboxlitit {
                  font-family: Poppins, Poppins;
                  font-weight: 500;
                  font-size: 26px;
                  color: #ffffff;
                  margin-top: 40px;
                  margin-bottom: 14px;
                }
                .pboxlicon {
                  display: flex;
                  justify-content: space-between;
                  .pboxlileft {
                    font-family: Poppins, Poppins;
                    font-weight: 400;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 0.6);
                    height: 27px;
                    line-height: 27px;
                    margin-bottom: 7px;
                  }
                  .pboxliright {
                    font-family: Poppins, Poppins;
                    font-weight: 400;
                    font-size: 18px;
                    color: #ffffff;
                    height: 27px;
                    line-height: 27px;
                    margin-bottom: 7px;
                  }
                }
                .pboxline {
                  width: 406px;
                  height: 0px;
                  border: 1px solid #30393a;
                  margin-top: 7px;
                  margin-bottom: 14px;
                }
              }
            }
            .pboxlitit {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 26px;
              color: #ffffff;
              margin-top: 40px;
              margin-bottom: 14px;
            }
            .pboxlicon {
              display: flex;
              justify-content: space-between;
              .pboxlileft {
                font-family: Poppins, Poppins;
                font-weight: 400;
                font-size: 18px;
                color: rgba(255, 255, 255, 0.6);
                height: 27px;
                line-height: 27px;
                margin-bottom: 7px;
              }
              .pboxliright {
                font-family: Poppins, Poppins;
                font-weight: 400;
                font-size: 18px;
                color: #ffffff;
                height: 27px;
                line-height: 27px;
                margin-bottom: 7px;
              }
            }
          }
        }
        .pboxlibox1 {
          width: 406px;
          margin: 0 auto;
          .pboxline {
            width: 406px;
            height: 0px;
            border: 1px solid #30393a;
            margin-top: 7px;
            margin-bottom: 14px;
          }
          // height: 390px;
        }
        .pboxlibox:last-child {
          .pboxline {
            width: 406px;
            height: 0px;
            border: 1px solid #30393a;
          }
        }
      }
      .pboxli:nth-child(3n) {
        margin-right: 0px;
      }
    }
  }
}
</style>
